import { FeatureDomain, LogEventSource, LogEventType } from '@akin-home/amplify';
import { createLogEventMutation } from '@akin-home/logging/frontend';
import { getLogEventPlatform } from './getLogEventPlatform';

interface Params<T> {
  type: LogEventType;
  user_id: string;
  feature_domain?: FeatureDomain
  data: T;
}

export const postLogEvent = <T>(params: Params<T>) => {
  const { data, ...rest } = params;

  return createLogEventMutation({
    input: {
      platform: getLogEventPlatform(),
      source: LogEventSource.HOME_AI_APP,
      data: JSON.stringify(data),
      ...rest,
    },
  });
};

export { Params as PostLogEventParams };

